// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Tajawal:wght@200;300;400;500;700;800;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
html, body {
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden; /* Prevent global scroll, let home handle it */
}
*{
  font-family:"Tajawal", sans-serif;
}
.app-wrapper {
  display: flex;
  flex-direction: column;
  height: 100vh; /* Force full viewport height */
  width: 100%;
  overflow: hidden;
}
/* The main wrapper for the home page */
.home {
  flex: 1 1; /* Takes up all remaining space below Nav and above Footer */
  display: flex;
  flex-direction: row; /* Desktop default */
  width: 100%;
  position: relative;
  overflow: hidden; /* Prevent scroll inside home */
}

/* LEFT SIDE: Marketing Section */
.home-marketing {
  flex: 1 1; /* Takes up 50% (or more if right side is constrained) */
  background-color: #f4f6f8; /* Light gray background */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px;
  position: relative;
  text-align: center;
}

.home-marketing h1 {
  font-size: 3rem;
  color: #333;
  margin-bottom: 10px;
}

.home-marketing p {
  font-size: 1.2rem;
  color: #666;
  max-width: 500px;
  margin-bottom: 30px;
}

/* Hero Image Placeholder */
.hero-image-placeholder {
  width: 100%;
  max-width: 400px;
  height: 300px;
  background-color: #e0e0e0;
  border-radius: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
  overflow: hidden;
}

.img-placeholder-box {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #83ae48, #5aa168);
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 1.5rem;
  font-weight: bold;
}

/* Small Footer */
.home-footer {
  position: absolute;
  bottom: 20px;
  font-size: 0.8rem;
  color: #999;
  width: 100%;
}

/* RIGHT SIDE: App Interface Container */
.home-app-container {
  flex: 0 0 50%; /* Fixed width for desktop "mobile" look */
  background-color: #fff;
  position: relative;
  height: 100%; /* Fill the height of .home */
  display: flex;
  flex-direction: column;
  justify-content: center; /* Vertical Center */
  align-items: center;     /* Horizontal Center */
  z-index: 100;
}

/* Keep the mobile overlay inside the right side */
.home-app-container .overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  background: linear-gradient(135deg, #a0d358, #599e67);

}

/* Ensure Nav and Content are on top of overlay */
.home-app-container nav,
.home-app-container h1,
.home-app-container .auth-modal,
.home-app-container .desktop-login-card {
  position: relative;
  z-index: 10;
}

.home {
  display: flex;
  flex-direction: row; /* Default */
  min-height: 100vh;
  position: relative;
}

/* Footer styles */
.home-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #fff;
  border-top: 1px solid #eee;
  padding: 15px 0;
  z-index: 1000; /* Above other content */
  text-align: center;
}

.footer-content {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 15px;
  font-size: 0.9rem;
  color: #666;
}

.footer-content .footer-links a {
  color: #5aa168;
  text-decoration: none;
  margin: 0 8px;
}

.primary-button {
  color: #fff;
  text-transform: uppercase;
  font-size: 15px;
  background: linear-gradient(45deg, #5aa168, #416f48);
  padding: 12px 30px;
  border-radius: 30px;
  border: none;
  
  /* NEW: Constrain Width */
  width: auto; /* Prevents stretching to 100% */
  min-width: 150px; /* Ensures it doesn't get too small */
  display: inline-block; /* Allows width to shrink to content */
  margin: 10px auto; /* Centers it horizontally */
  cursor: pointer;
  z-index: 1;
}

.primary-button:hover {
  background: linear-gradient(260deg, #5aa168, #416f48);
}
/*-----Nav bar -----*/
nav{
  width: 100%;
  display:flex;
  justify-content:space-between;
}

nav .login-button{
  color: #84af49;
  background-color: rgb(255,255,255);
  font-size: 20px;
  padding: 10px 20px;
  border-radius: 10px;
  border: none;
  margin: 10px;
}

nav .login-button:disabled{
    display:none;

}
nav .login-button:hover {
    color: #e74c3c;
    cursor: pointer;
}

.secondary-button{
    background: linear-gradient(45deg, #5aa168, #29c03f);
    border-style: solid;
    border-radius: 10%;
    height: 35px;
    cursor: pointer;
}
.secondary-button:hover{
    cursor: pointer;
}
nav .logo-container {
  width: 170px;
  margin: 15px;
}

nav .logo-container .logo {
  width: 50%;
}
/*-----Auth Modal -----*/
.auth-modal {
  max-width: 320px;
  background-color: #ffffff;
  border-radius: 20px;
  padding: 25px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.2);
  z-index: 10;
  margin-bottom: 20px; /* Space between modal and button */
}

.auth-modal h2 {
  font-size: 1.8rem;
  margin: 0 0 10px 0;
  color: #2c3e50;
  font-weight: 700;
}
.auth-modal p {
  font-size: 0.95rem;
  color: #7f8c8d;
  margin-bottom: 25px;
}

.auth-modal .form {
  display: flex;
  flex-direction: column;
  gap: 15px; /* Consistent spacing between inputs */
}
.auth-modal input { 
    padding: 10px; 
    margin: 10px 0; 
    font-size: 16px; 
    border: 1px solid #ccc; 
    border-radius: 5px; 
}


.auth-modal .form{
  display: flex;
  flex-direction: column;
}

.auth-modal input[type="username"],
.auth-modal input[type="email"],
.auth-modal input[type="password"]
{
  width: 100%;
  padding: 14px 16px;
  font-size: 16px; /* Prevents zoom on iOS */
  color: #333;
  background-color: #f8f9fa;
  border: 1px solid #e0e0e0;
  border-radius: 12px; /* Rounded inputs */
  transition: all 0.3s ease;
  box-sizing: border-box;
  outline: none;
}
.auth-modal input:focus {
  background-color: #fff;
  border-color: #5aa168;
  box-shadow: 0 0 0 4px rgba(90, 161, 104, 0.15);
}
.auth-modal input::placeholder {
  color: #bdc3c7;
}
.secondary-button {
  width: 100%; /* Full width for easier touch target */
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.5px;
  padding-bottom: 10px;
}

/* Hover Effect for Modal Button */
.secondary-button:hover {
  transform: translateY(-2px); /* Subtle lift */
  box-shadow: 0 5px 15px rgba(90, 161, 104, 0.4);
}
.log-out-img-container {
    height: 100%;
    width: 100%;
    position: relative;
    overflow: hidden;
    
}

.log-out-img-container img {
    width: 80%;
    height: 100%;
    filter: brightness(0) invert(1);
}

.menu-options{
    display: flex;
    flex-direction: column;
}

.menu-options .option:hover{
    cursor: pointer;
    color: #e74c3c;
}
.menu-options .option:disabled{
    color: black;
}
@media (max-width: 1400px) {
    .card-wrapper{
        width: 45% !important;
    }
}
@media (max-width: 768px) {
  /* 1. Ensure Home takes full available height */
  .home {
    flex-direction: column;
    width: 100%;
    max-width: 100%;
    /* Remove min-height, let flex:1 from .home handle it */
    height: 100%; 
  }

  .home-marketing {
    display: none;
  }
  /* 2. App Container: Force Full Height */
  .home-app-container {
    flex: none;
    width: 100%;
    height: 100%; /* Fill 100% of .home's height */
    min-height: 100%; /* Ensure it doesn't shrink below parent */
    position: relative;
    overflow: hidden; /* Keep scroll disabled */
    
    /* Flex Centering for content */
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    
    box-shadow: none;
    z-index: 100;
  }
  .home-app-container h1 {
    position: relative; /* Enables z-index */
    margin: 20px 0;
    }

  /* 3. Overlay: Ensure it covers the container */
  .home-app-container .overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%; /* Cover the full height of .home-app-container */
    pointer-events: none;
    background: linear-gradient(135deg, #a0d358, #599e67);
  }

  /* 4. Content Z-Index */
  .home-app-container h1,
  .auth-modal,
  .home-app-container .primary-button {
    z-index: 10; /* Ensure they are above the overlay */
    position: relative; /* Ensure z-index applies */
  }

  /* 5. Modal & Button Sizing */
  .auth-modal{
    width: 85%;
  }
  .profile-img-container{
    height: 50px !important;
    width: 50px !important;
  }
.swipe-container-header-add-item-container {
    height: 100% !important;
    width: 30% !important;
}
.card-container {
    height: 300px !important;
}
.card-wrapper {
    width: 90% !important;
    height: 270px !important;
}
.card-content {
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    
    /* Flexbox to center the description */
    display: flex;
    justify-content: center; /* Horizontal centering */
    align-items: end;     /* Vertical centering */
    
    /* Optional: If you want the text to stay at the bottom instead */
    /* align-items: flex-end; */
    /* padding-bottom: 20px; */
}
.home-footer {
    display: none; 
  }
.home-footer-full {
    position: relative; /* Flow normally on mobile */
    width: 100%;
}
.match-card{
    width: 70% !important;
    height: 20% !important;
}
.own-card{
    width: 70% !important;
    height: 20% !important;
}
.chat-display .img-container{
    width: 45px !important;
    height: 45px !important;
    margin-bottom: 10px;
    border-radius: 12px;
}
p{
    font-size: 16px !important;
}
}
/*-----Onboarding Page------*/
.onboarding {
    border-top: solid 1px rgb(213, 213, 213);
}

.onboarding form {
    display: flex;
    justify-content: center;
}

.onboarding form section {
    display: flex;
    flex-direction: column;
    padding: 20px;
    width: 45%;
    text-align: start;
}
.onboarding form section:nth-child(2){
    width: 40%;
}

.onboarding form input,
.onboarding form select {
    padding: 15px 30px;
    margin: 10px 0;
    font-size: 15px;
    border: solid 2px rgb(219, 219, 219);
    border-radius: 10px;
}

.onboarding form label {
    margin: 7px 0;
}

.onboarding form .multiple-input-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}

.onboarding form input::-webkit-outer-spin-button,
.onboarding form input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.onboarding form .multiple-input-container input {
    margin-right: 10px;
}

.onboarding form .multiple-input-container label {
    padding: 10px;
    border: solid 2px rgb(144, 144, 144);
    border-radius: 10px;
    transition: all 0.3s;
    margin-right: 10px;
}

.onboarding form input[type=radio],
.additem form input[type=file],
.onboarding form input[type=file] {
    display: none;
}

.onboarding form input[type=radio]:checked + label {
    border: solid 2px #5aa168;
}

.onboarding form input[type=submit]:hover {
    background-color: rgb(235, 235, 235);
}

.onboarding form input[type=submit]:active {
    background-color: #5aa168;
}
.additem form .uploaded-pic-div,
.onboarding form .uploaded-pic-div{
    display: flex;
    flex-direction: row;
    width: 100%
}
.additem form .pic-upload-src-div,
.onboarding form .pic-upload-src-div{
    padding: 5px 5px;
    margin: 10px 0px 10px 0px;
    font-size: 15px;
    border: solid 2px rgb(219, 219, 219);
    border-radius: 10px;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    width: 95%;
}
.additem .form .pic-upload-src-div img,
.onboarding .form .pic-upload-src-div img{
    width: 30px;
}
.additem .form .photo-container,
.onboarding .form .photo-container {
    width: 100%
}
.additem .form .uploaded-pic-delete-container,
.onboarding .form .uploaded-pic-delete-container {
    margin-left: -20%;
    width: 20%
}
.additem form .photo-container img,
.onboarding form .photo-container img{
    width: 100%;
}
.additem form .uploaded-pic-delete-container #uploaded-pic img,
.onboarding form .uploaded-pic-delete-container #uploaded-pic img{
    width: 80%;
}
.additem form .custom-file-upload,
.onboarding form .custom-file-upload {
    border: 1px solid #ccc;
    display: contents;
    padding: 6px 12px;
    cursor: pointer;

}
.additem form .file-upload-div,
.onboarding form .file-upload-div{
    display: flex;
    flex-direction: column

}
.additem form .custom-file-upload .fa-cloud-upload,
.onboarding form .custom-file-upload .fa-cloud-upload {
    justify-content: center;
}
.onboarding h2,
.additem h2{
    position: relative;
    margin-left: 4%;
    margin-bottom: 0%;
}
/*-----AddItem-----*/
.additem {
    border-top: solid 1px rgb(213, 213, 213);
}

.additem form {
    display: flex;
    justify-content: center;
}

.additem form section {
    display: flex;
    flex-direction: column;
    padding: 20px;
    width: 45%;
    text-align: start;
}

.additem form input,
.additem form select {
    padding: 15px 30px;
    margin: 10px 0;
    font-size: 15px;
    border: solid 2px rgb(219, 219, 219);
    border-radius: 10px;
}

.additem form label {
    margin: 10px 0;
}

.additem form .multiple-input-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}

.additem form input::-webkit-outer-spin-button,
.additem form input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.additem form .multiple-input-container input {
    margin-right: 10px;
}

.additem form .multiple-input-container label {
    padding: 10px;
    border: solid 2px rgb(144, 144, 144);
    border-radius: 10px;
    transition: all 0.3s;
    margin-right: 10px;
}

.additem form input[type=radio] {
    display: none;
}

.additem form input[type=number] {
    width: 25%;
}
.additem form select {
    width: 80%;
}

.additem form input[type=radio]:checked + label {
    border: solid 2px #5aa168;
}

.additem form input[type=submit]:hover {
    background-color: rgb(235, 235, 235);
}

.additem form input[type=submit]:active {
    background-color: rgb(226, 115, 115);
}

/*----Dashboard-----*/
.dashboard {
    display: flex;
    justify-content: space-between;
}

.swipe-container {
    width: 70vw;
    display: flex;
    height: 100vh;
    z-index: 1;

    align-items: flex-start;
    flex-direction: column;
    position: absolute;
    right: 0%;

}
.swipe-container .swipe-container-header{
    background: linear-gradient(45deg, #83ae48, #5aa168);
    height: 100px;
    width: 100%;
    justify-content: flex-end;
    align-items:center;
    display: flex;
}

.swipe-container-header-add-item-container {
    height: 75px;
    width: 75px;
    position: relative;
    overflow: hidden;
    margin: 10px;
    display: flex;
    align-items:center;

}
.swipe-container-header-add-item-container img {
    height: 70%;
    width: 100%;
}

.card-container {
    background: linear-gradient(45deg, #83ae48, #5aa168);
    width: 100%;
    height: 600px;
    overflow-y: auto;
    display: flex; /* Optional, if you have other static content */
    justify-content: center;
    align-items: center;
}


.dashboard .swipe-info {
    position: absolute;
    bottom: 0;
    padding: 10px;
}
.card-wrapper {
    position: absolute; /* Required by react-tinder-card */
    width: 35%;
    height: 35%;
    border-radius: 20px;
    overflow: hidden; /* Keeps content inside rounded corners */
    transform: translate(-50%, -50%); /* Offset by half its own size */
}
.card-content {
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    position: absolute; /* Required by react-tinder-card */

    /* Flexbox to center the description */
    display: flex;
    justify-content: center; /* Horizontal centering */
    align-items: end;     /* Vertical centering */
    
    /* Optional: If you want the text to stay at the bottom instead */
    /* align-items: flex-end; */
    /* padding-bottom: 20px; */
}

.card-description {
    text-align: center; /* Centers text lines within the description block */
    color: white;       /* Ensure text is visible on images */
    padding: 10px;
    background-color: rgba(0, 0, 0, 0.5); /* Optional: backdrop for readability */
    border-radius: 10px;
    width: 100%; /* Prevents text from touching edges */
    bottom: 0;
    position: relative;
}
.card-description img {
    width: 7%;
    height: 7%;
    filter: invert(100%);
    margin-bottom: 0%;
}
.card-description .description img{
    margin-top: 1%;
    margin-left: 3%;
}
.card-description .specs img{
    margin-top: 3%;
    margin-right: 3%;
    margin-left: 3%;
}
.card-description h4 {
    color: #fff;
    margin-bottom: 0%;
    margin-top: 0%;
}
.card-description span {
    color: #d8d7d7;
    margin-left: 0%;
    margin-top: 0%;
}
/*-------- Chat Container --------*/
.chat-container {
    background-color: rgb(255, 255, 255);
    box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
    rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
    width: 30%;
    text-align: left;
    z-index: 1;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
}

.chat-container .chat-container-header {
    background: linear-gradient(45deg,  #83ae48, #5aa168);
    height: 100px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.chat-container .option {
    border: none;
    background-color: rgb(255, 255, 255);
    border-bottom: solid 4px #5aa168;
    font-size: 20px;
    margin: 2px;
    padding: 10px;
}

.chat-container .option:disabled {
    border-bottom: solid 4px rgb(187, 187, 187);
}

.chat-container .profile,
.chat-container .log-out-icon {
    display: flex;
    align-items: center;
    padding: 10%;
    width: 50%;
    color: rgb(255, 255, 255);
}

/* Image styling */
.image {
    width: 100%;
}

.profile-img-container{
    height: 50px;
    width: 50px;
    border-radius: 15px;
    overflow: hidden;
    margin: 10px;
    position:relative;
}

.profile-img-container img {
    width: 100%;
}
/*-------- Chat Display --------*/
.chat-display{
    padding: 5px;
    overflow-y: auto;
    height: 40vh;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
}
.chat-display .img-container{
    width: 20%;
    height: 20%;
    margin-bottom: 20px;
    margin-top: 20px;
    border-radius: 12px;
}
.chat-display .message-other-user .img-container{
    position: absolute;
    right: 0px;
}

.matches-display {
    padding-top: 10px;
    overflow-y: scroll;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    height: 60vh;
}
.matches-display .match-card{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 30%;
    margin-bottom: 10px;
    border-radius: 12px;

}
.own-card {
    display: flex;
    position: relative; /* Anchor for absolute children */
    width: 30%;       /* Your desired width */
    border-radius: 12px;
    cursor: pointer;
    display: flex;
    margin-bottom: 10px;
}

/* --- Overlays --- */

.edit {
    position: absolute;
    top: 0%;
    left: 0%;
    width: 30%;
    height: 30%;
    background-color: rgba(0,0,0,0.3);
    border-radius: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    z-index: 2; /* Above image */
    transition: transform 0.2s, background-color 0.2s;
}

.edit:hover {
    transform: scale(1.1);
}

.edit img {
    width: 90%;
    height: 90%;
}

.counter {
    position: absolute;
    background-color: rgba(0,0,0,0.3);
    top: 0%;
    right: 0%;
    color: white;
    border-radius: 12px;
    font-size: 100%;
    font-weight: bold;
    z-index: 2; /* Above image */
    width: 30%;
    height: 30%;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
}

/* --- Background Image --- */

.img-container {
    width: 100%;
    height: 100%;
}

.img-container img {
    width: 100%;
    height: 100%;
    border-radius: 15px;
    object-fit: cover;
    display: block;
}
/*-------- Chat Input --------*/
.chat-input {
    padding: 5px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    flex: 1 1;
}
/*--------- Slider Bar -------*/
.slider-container {
    display: flex;
    flex-direction: column;
    justify-content: center; /* Centers items horizontally */
    align-items: center;     /* Centers items vertically */
    gap: 20px;               /* Adds space between elements */
    
    /* Optional: Define width/height if needed */
    width: 100%;
    padding: 20px 0;
    
    /* If you want it fixed at the bottom of the swipe-container */
    /* position: absolute; */
    /* bottom: 20px; */
}
  
.slider {
    width: 300px;
    max-width: 90%;
    margin: 10px 0;
}

.value-display {
    font-size: 18px;
    font-weight: bold;
    color: #333;
}
p{
    text-align: center;
    margin: 0 5px 0 5px;
    font-size: 34px;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":";AAIA;EACE,YAAY;EACZ,SAAS;EACT,UAAU;EACV,gBAAgB,EAAE,8CAA8C;AAClE;AACA;EACE,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa,EAAE,+BAA+B;EAC9C,WAAW;EACX,gBAAgB;AAClB;AACA,uCAAuC;AACvC;EACE,SAAO,EAAE,4DAA4D;EACrE,aAAa;EACb,mBAAmB,EAAE,oBAAoB;EACzC,WAAW;EACX,kBAAkB;EAClB,gBAAgB,EAAE,+BAA+B;AACnD;;AAEA,iCAAiC;AACjC;EACE,SAAO,EAAE,wDAAwD;EACjE,yBAAyB,EAAE,0BAA0B;EACrD,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qDAAqD;EACrD,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,WAAW;AACb;;AAEA,wCAAwC;AACxC;EACE,aAAa,EAAE,0CAA0C;EACzD,sBAAsB;EACtB,kBAAkB;EAClB,YAAY,EAAE,6BAA6B;EAC3C,aAAa;EACb,sBAAsB;EACtB,uBAAuB,EAAE,oBAAoB;EAC7C,mBAAmB,MAAM,sBAAsB;EAC/C,YAAY;AACd;;AAEA,kDAAkD;AAClD;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,qDAAqD;;AAEvD;;AAEA,iDAAiD;AACjD;;;;EAIE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB,EAAE,YAAY;EACjC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,sBAAsB;EACtB,0BAA0B;EAC1B,eAAe;EACf,aAAa,EAAE,wBAAwB;EACvC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,oDAAoD;EACpD,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;;EAEZ,yBAAyB;EACzB,WAAW,EAAE,gCAAgC;EAC7C,gBAAgB,EAAE,qCAAqC;EACvD,qBAAqB,EAAE,sCAAsC;EAC7D,iBAAiB,EAAE,4BAA4B;EAC/C,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,qDAAqD;AACvD;AACA,qBAAqB;AACrB;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;IACI,YAAY;;AAEhB;AACA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,oDAAoD;IACpD,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;AACA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,uCAAuC;EACvC,WAAW;EACX,mBAAmB,EAAE,mCAAmC;AAC1D;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAE,sCAAsC;AACnD;AACA;IACI,aAAa;IACb,cAAc;IACd,eAAe;IACf,sBAAsB;IACtB,kBAAkB;AACtB;;;AAGA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;;;;EAIE,WAAW;EACX,kBAAkB;EAClB,eAAe,EAAE,yBAAyB;EAC1C,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB,EAAE,mBAAmB;EACxC,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,8CAA8C;AAChD;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW,EAAE,uCAAuC;EACpD,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA,kCAAkC;AAClC;EACE,2BAA2B,EAAE,gBAAgB;EAC7C,8CAA8C;AAChD;AACA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,gBAAgB;;AAEpB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;AACA;IACI,YAAY;AAChB;AACA;IACI;QACI,qBAAqB;IACzB;AACJ;AACA;EACE,+CAA+C;EAC/C;IACE,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,uDAAuD;IACvD,YAAY;EACd;;EAEA;IACE,aAAa;EACf;EACA,wCAAwC;EACxC;IACE,UAAU;IACV,WAAW;IACX,YAAY,EAAE,gCAAgC;IAC9C,gBAAgB,EAAE,0CAA0C;IAC5D,kBAAkB;IAClB,gBAAgB,EAAE,yBAAyB;;IAE3C,+BAA+B;IAC/B,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;;IAEnB,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,kBAAkB,EAAE,oBAAoB;IACxC,cAAc;IACd;;EAEF,+CAA+C;EAC/C;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY,EAAE,iDAAiD;IAC/D,oBAAoB;IACpB,qDAAqD;EACvD;;EAEA,uBAAuB;EACvB;;;IAGE,WAAW,EAAE,sCAAsC;IACnD,kBAAkB,EAAE,2BAA2B;EACjD;;EAEA,6BAA6B;EAC7B;IACE,UAAU;EACZ;EACA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;AACF;IACI,uBAAuB;IACvB,qBAAqB;AACzB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,qBAAqB;IACrB,wBAAwB;AAC5B;AACA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,2BAA2B;;IAE3B,sCAAsC;IACtC,aAAa;IACb,uBAAuB,EAAE,yBAAyB;IAClD,gBAAgB,MAAM,uBAAuB;;IAE7C,iEAAiE;IACjE,2BAA2B;IAC3B,0BAA0B;AAC9B;AACA;IACI,aAAa;EACf;AACF;IACI,kBAAkB,EAAE,4BAA4B;IAChD,WAAW;AACf;AACA;IACI,qBAAqB;IACrB,sBAAsB;AAC1B;AACA;IACI,qBAAqB;IACrB,sBAAsB;AAC1B;AACA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,0BAA0B;AAC9B;AACA;AACA,6BAA6B;AAC7B;IACI,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,UAAU;IACV,iBAAiB;AACrB;AACA;IACI,UAAU;AACd;;AAEA;;IAEI,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,oCAAoC;IACpC,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;;IAEI,wBAAwB;IACxB,SAAS;AACb;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,oCAAoC;IACpC,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;;;IAGI,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;AACA;;IAEI,aAAa;IACb,mBAAmB;IACnB;AACJ;AACA;;IAEI,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;IACf,oCAAoC;IACpC,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,UAAU;AACd;AACA;;IAEI,WAAW;AACf;AACA;;IAEI;AACJ;AACA;;IAEI,iBAAiB;IACjB;AACJ;AACA;;IAEI,WAAW;AACf;AACA;;IAEI,UAAU;AACd;AACA;;IAEI,sBAAsB;IACtB,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;;AAEnB;AACA;;IAEI,aAAa;IACb;;AAEJ;AACA;;IAEI,uBAAuB;AAC3B;AACA;;IAEI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;AACA,oBAAoB;AACpB;IACI,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,UAAU;IACV,iBAAiB;AACrB;;AAEA;;IAEI,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,oCAAoC;IACpC,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;;IAEI,wBAAwB;IACxB,SAAS;AACb;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,oCAAoC;IACpC,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,aAAa;IACb,UAAU;;IAEV,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;;AAEb;AACA;IACI,oDAAoD;IACpD,aAAa;IACb,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,kBAAkB;;AAEtB;AACA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,oDAAoD;IACpD,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,aAAa,EAAE,+CAA+C;IAC9D,uBAAuB;IACvB,mBAAmB;AACvB;;;AAGA;IACI,kBAAkB;IAClB,SAAS;IACT,aAAa;AACjB;AACA;IACI,kBAAkB,EAAE,kCAAkC;IACtD,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,gBAAgB,EAAE,yCAAyC;IAC3D,gCAAgC,EAAE,gCAAgC;AACtE;AACA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,2BAA2B;IAC3B,kBAAkB,EAAE,kCAAkC;;IAEtD,sCAAsC;IACtC,aAAa;IACb,uBAAuB,EAAE,yBAAyB;IAClD,gBAAgB,MAAM,uBAAuB;;IAE7C,iEAAiE;IACjE,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB,EAAE,oDAAoD;IACxE,YAAY,QAAQ,qCAAqC;IACzD,aAAa;IACb,oCAAoC,EAAE,uCAAuC;IAC7E,mBAAmB;IACnB,WAAW,EAAE,sCAAsC;IACnD,SAAS;IACT,kBAAkB;AACtB;AACA;IACI,SAAS;IACT,UAAU;IACV,oBAAoB;IACpB,iBAAiB;AACrB;AACA;IACI,cAAc;IACd,eAAe;AACnB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,WAAW;IACX,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,cAAc;IACd,eAAe;IACf,cAAc;AAClB;AACA,mCAAmC;AACnC;IACI,oCAAoC;IACpC;uCACmC;IACnC,UAAU;IACV,gBAAgB;IAChB,UAAU;IACV,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,qDAAqD;IACrD,aAAa;IACb,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,oCAAoC;IACpC,gCAAgC;IAChC,eAAe;IACf,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,UAAU;IACV,yBAAyB;AAC7B;;AAEA,kBAAkB;AAClB;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;AACA,iCAAiC;AACjC;IACI,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,2BAA2B;AAC/B;AACA;IACI,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;IAC3B,YAAY;AAChB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,mBAAmB;IACnB,mBAAmB;;AAEvB;AACA;IACI,aAAa;IACb,kBAAkB,EAAE,iCAAiC;IACrD,UAAU,QAAQ,uBAAuB;IACzC,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,mBAAmB;AACvB;;AAEA,qBAAqB;;AAErB;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,UAAU;IACV,WAAW;IACX,iCAAiC;IACjC,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,UAAU,EAAE,gBAAgB;IAC5B,iDAAiD;AACrD;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,iCAAiC;IACjC,OAAO;IACP,SAAS;IACT,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,UAAU,EAAE,gBAAgB;IAC5B,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA,6BAA6B;;AAE7B;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;AAClB;AACA,+BAA+B;AAC/B;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,SAAO;AACX;AACA,+BAA+B;AAC/B;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB,EAAE,+BAA+B;IACxD,mBAAmB,MAAM,6BAA6B;IACtD,SAAS,gBAAgB,gCAAgC;;IAEzD,4CAA4C;IAC5C,WAAW;IACX,eAAe;;IAEf,8DAA8D;IAC9D,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;AACnB","sourcesContent":["\n@import url('https://fonts.googleapis.com/css2?family=Tajawal:wght@200;300;400;500;700;800;900&display=swap');\n\n\nhtml, body {\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  overflow: hidden; /* Prevent global scroll, let home handle it */\n}\n*{\n  font-family:\"Tajawal\", sans-serif;\n}\n.app-wrapper {\n  display: flex;\n  flex-direction: column;\n  height: 100vh; /* Force full viewport height */\n  width: 100%;\n  overflow: hidden;\n}\n/* The main wrapper for the home page */\n.home {\n  flex: 1; /* Takes up all remaining space below Nav and above Footer */\n  display: flex;\n  flex-direction: row; /* Desktop default */\n  width: 100%;\n  position: relative;\n  overflow: hidden; /* Prevent scroll inside home */\n}\n\n/* LEFT SIDE: Marketing Section */\n.home-marketing {\n  flex: 1; /* Takes up 50% (or more if right side is constrained) */\n  background-color: #f4f6f8; /* Light gray background */\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 40px;\n  position: relative;\n  text-align: center;\n}\n\n.home-marketing h1 {\n  font-size: 3rem;\n  color: #333;\n  margin-bottom: 10px;\n}\n\n.home-marketing p {\n  font-size: 1.2rem;\n  color: #666;\n  max-width: 500px;\n  margin-bottom: 30px;\n}\n\n/* Hero Image Placeholder */\n.hero-image-placeholder {\n  width: 100%;\n  max-width: 400px;\n  height: 300px;\n  background-color: #e0e0e0;\n  border-radius: 15px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  box-shadow: 0 10px 30px rgba(0,0,0,0.1);\n  overflow: hidden;\n}\n\n.img-placeholder-box {\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(135deg, #83ae48, #5aa168);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: white;\n  font-size: 1.5rem;\n  font-weight: bold;\n}\n\n/* Small Footer */\n.home-footer {\n  position: absolute;\n  bottom: 20px;\n  font-size: 0.8rem;\n  color: #999;\n  width: 100%;\n}\n\n/* RIGHT SIDE: App Interface Container */\n.home-app-container {\n  flex: 0 0 50%; /* Fixed width for desktop \"mobile\" look */\n  background-color: #fff;\n  position: relative;\n  height: 100%; /* Fill the height of .home */\n  display: flex;\n  flex-direction: column;\n  justify-content: center; /* Vertical Center */\n  align-items: center;     /* Horizontal Center */\n  z-index: 100;\n}\n\n/* Keep the mobile overlay inside the right side */\n.home-app-container .overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  background: linear-gradient(135deg, #a0d358, #599e67);\n\n}\n\n/* Ensure Nav and Content are on top of overlay */\n.home-app-container nav,\n.home-app-container h1,\n.home-app-container .auth-modal,\n.home-app-container .desktop-login-card {\n  position: relative;\n  z-index: 10;\n}\n\n.home {\n  display: flex;\n  flex-direction: row; /* Default */\n  min-height: 100vh;\n  position: relative;\n}\n\n/* Footer styles */\n.home-footer {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  background-color: #fff;\n  border-top: 1px solid #eee;\n  padding: 15px 0;\n  z-index: 1000; /* Above other content */\n  text-align: center;\n}\n\n.footer-content {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 15px;\n  font-size: 0.9rem;\n  color: #666;\n}\n\n.footer-content .footer-links a {\n  color: #5aa168;\n  text-decoration: none;\n  margin: 0 8px;\n}\n\n.primary-button {\n  color: #fff;\n  text-transform: uppercase;\n  font-size: 15px;\n  background: linear-gradient(45deg, #5aa168, #416f48);\n  padding: 12px 30px;\n  border-radius: 30px;\n  border: none;\n  \n  /* NEW: Constrain Width */\n  width: auto; /* Prevents stretching to 100% */\n  min-width: 150px; /* Ensures it doesn't get too small */\n  display: inline-block; /* Allows width to shrink to content */\n  margin: 10px auto; /* Centers it horizontally */\n  cursor: pointer;\n  z-index: 1;\n}\n\n.primary-button:hover {\n  background: linear-gradient(260deg, #5aa168, #416f48);\n}\n/*-----Nav bar -----*/\nnav{\n  width: 100%;\n  display:flex;\n  justify-content:space-between;\n}\n\nnav .login-button{\n  color: #84af49;\n  background-color: rgb(255,255,255);\n  font-size: 20px;\n  padding: 10px 20px;\n  border-radius: 10px;\n  border: none;\n  margin: 10px;\n}\n\nnav .login-button:disabled{\n    display:none;\n\n}\nnav .login-button:hover {\n    color: #e74c3c;\n    cursor: pointer;\n}\n\n.secondary-button{\n    background: linear-gradient(45deg, #5aa168, #29c03f);\n    border-style: solid;\n    border-radius: 10%;\n    height: 35px;\n    cursor: pointer;\n}\n.secondary-button:hover{\n    cursor: pointer;\n}\nnav .logo-container {\n  width: 170px;\n  margin: 15px;\n}\n\nnav .logo-container .logo {\n  width: 50%;\n}\n/*-----Auth Modal -----*/\n.auth-modal {\n  max-width: 320px;\n  background-color: #ffffff;\n  border-radius: 20px;\n  padding: 25px;\n  box-shadow: 0 10px 30px rgba(0,0,0,0.2);\n  z-index: 10;\n  margin-bottom: 20px; /* Space between modal and button */\n}\n\n.auth-modal h2 {\n  font-size: 1.8rem;\n  margin: 0 0 10px 0;\n  color: #2c3e50;\n  font-weight: 700;\n}\n.auth-modal p {\n  font-size: 0.95rem;\n  color: #7f8c8d;\n  margin-bottom: 25px;\n}\n\n.auth-modal .form {\n  display: flex;\n  flex-direction: column;\n  gap: 15px; /* Consistent spacing between inputs */\n}\n.auth-modal input { \n    padding: 10px; \n    margin: 10px 0; \n    font-size: 16px; \n    border: 1px solid #ccc; \n    border-radius: 5px; \n}\n\n\n.auth-modal .form{\n  display: flex;\n  flex-direction: column;\n}\n\n.auth-modal input[type=\"username\"],\n.auth-modal input[type=\"email\"],\n.auth-modal input[type=\"password\"]\n{\n  width: 100%;\n  padding: 14px 16px;\n  font-size: 16px; /* Prevents zoom on iOS */\n  color: #333;\n  background-color: #f8f9fa;\n  border: 1px solid #e0e0e0;\n  border-radius: 12px; /* Rounded inputs */\n  transition: all 0.3s ease;\n  box-sizing: border-box;\n  outline: none;\n}\n.auth-modal input:focus {\n  background-color: #fff;\n  border-color: #5aa168;\n  box-shadow: 0 0 0 4px rgba(90, 161, 104, 0.15);\n}\n.auth-modal input::placeholder {\n  color: #bdc3c7;\n}\n.secondary-button {\n  width: 100%; /* Full width for easier touch target */\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n  padding-bottom: 10px;\n}\n\n/* Hover Effect for Modal Button */\n.secondary-button:hover {\n  transform: translateY(-2px); /* Subtle lift */\n  box-shadow: 0 5px 15px rgba(90, 161, 104, 0.4);\n}\n.log-out-img-container {\n    height: 100%;\n    width: 100%;\n    position: relative;\n    overflow: hidden;\n    \n}\n\n.log-out-img-container img {\n    width: 80%;\n    height: 100%;\n    filter: brightness(0) invert(1);\n}\n\n.menu-options{\n    display: flex;\n    flex-direction: column;\n}\n\n.menu-options .option:hover{\n    cursor: pointer;\n    color: #e74c3c;\n}\n.menu-options .option:disabled{\n    color: black;\n}\n@media (max-width: 1400px) {\n    .card-wrapper{\n        width: 45% !important;\n    }\n}\n@media (max-width: 768px) {\n  /* 1. Ensure Home takes full available height */\n  .home {\n    flex-direction: column;\n    width: 100%;\n    max-width: 100%;\n    /* Remove min-height, let flex:1 from .home handle it */\n    height: 100%; \n  }\n\n  .home-marketing {\n    display: none;\n  }\n  /* 2. App Container: Force Full Height */\n  .home-app-container {\n    flex: none;\n    width: 100%;\n    height: 100%; /* Fill 100% of .home's height */\n    min-height: 100%; /* Ensure it doesn't shrink below parent */\n    position: relative;\n    overflow: hidden; /* Keep scroll disabled */\n    \n    /* Flex Centering for content */\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n    \n    box-shadow: none;\n    z-index: 100;\n  }\n  .home-app-container h1 {\n    position: relative; /* Enables z-index */\n    margin: 20px 0;\n    }\n\n  /* 3. Overlay: Ensure it covers the container */\n  .home-app-container .overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%; /* Cover the full height of .home-app-container */\n    pointer-events: none;\n    background: linear-gradient(135deg, #a0d358, #599e67);\n  }\n\n  /* 4. Content Z-Index */\n  .home-app-container h1,\n  .auth-modal,\n  .home-app-container .primary-button {\n    z-index: 10; /* Ensure they are above the overlay */\n    position: relative; /* Ensure z-index applies */\n  }\n\n  /* 5. Modal & Button Sizing */\n  .auth-modal{\n    width: 85%;\n  }\n  .profile-img-container{\n    height: 50px !important;\n    width: 50px !important;\n  }\n.swipe-container-header-add-item-container {\n    height: 100% !important;\n    width: 30% !important;\n}\n.card-container {\n    height: 300px !important;\n}\n.card-wrapper {\n    width: 90% !important;\n    height: 270px !important;\n}\n.card-content {\n    width: 100%;\n    height: 100%;\n    background-size: cover;\n    background-position: center;\n    \n    /* Flexbox to center the description */\n    display: flex;\n    justify-content: center; /* Horizontal centering */\n    align-items: end;     /* Vertical centering */\n    \n    /* Optional: If you want the text to stay at the bottom instead */\n    /* align-items: flex-end; */\n    /* padding-bottom: 20px; */\n}\n.home-footer {\n    display: none; \n  }\n.home-footer-full {\n    position: relative; /* Flow normally on mobile */\n    width: 100%;\n}\n.match-card{\n    width: 70% !important;\n    height: 20% !important;\n}\n.own-card{\n    width: 70% !important;\n    height: 20% !important;\n}\n.chat-display .img-container{\n    width: 45px !important;\n    height: 45px !important;\n    margin-bottom: 10px;\n    border-radius: 12px;\n}\np{\n    font-size: 16px !important;\n}\n}\n/*-----Onboarding Page------*/\n.onboarding {\n    border-top: solid 1px rgb(213, 213, 213);\n}\n\n.onboarding form {\n    display: flex;\n    justify-content: center;\n}\n\n.onboarding form section {\n    display: flex;\n    flex-direction: column;\n    padding: 20px;\n    width: 45%;\n    text-align: start;\n}\n.onboarding form section:nth-child(2){\n    width: 40%;\n}\n\n.onboarding form input,\n.onboarding form select {\n    padding: 15px 30px;\n    margin: 10px 0;\n    font-size: 15px;\n    border: solid 2px rgb(219, 219, 219);\n    border-radius: 10px;\n}\n\n.onboarding form label {\n    margin: 7px 0;\n}\n\n.onboarding form .multiple-input-container {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n}\n\n.onboarding form input::-webkit-outer-spin-button,\n.onboarding form input::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\n.onboarding form .multiple-input-container input {\n    margin-right: 10px;\n}\n\n.onboarding form .multiple-input-container label {\n    padding: 10px;\n    border: solid 2px rgb(144, 144, 144);\n    border-radius: 10px;\n    transition: all 0.3s;\n    margin-right: 10px;\n}\n\n.onboarding form input[type=radio],\n.additem form input[type=file],\n.onboarding form input[type=file] {\n    display: none;\n}\n\n.onboarding form input[type=radio]:checked + label {\n    border: solid 2px #5aa168;\n}\n\n.onboarding form input[type=submit]:hover {\n    background-color: rgb(235, 235, 235);\n}\n\n.onboarding form input[type=submit]:active {\n    background-color: #5aa168;\n}\n.additem form .uploaded-pic-div,\n.onboarding form .uploaded-pic-div{\n    display: flex;\n    flex-direction: row;\n    width: 100%\n}\n.additem form .pic-upload-src-div,\n.onboarding form .pic-upload-src-div{\n    padding: 5px 5px;\n    margin: 10px 0px 10px 0px;\n    font-size: 15px;\n    border: solid 2px rgb(219, 219, 219);\n    border-radius: 10px;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-evenly;\n    width: 95%;\n}\n.additem .form .pic-upload-src-div img,\n.onboarding .form .pic-upload-src-div img{\n    width: 30px;\n}\n.additem .form .photo-container,\n.onboarding .form .photo-container {\n    width: 100%\n}\n.additem .form .uploaded-pic-delete-container,\n.onboarding .form .uploaded-pic-delete-container {\n    margin-left: -20%;\n    width: 20%\n}\n.additem form .photo-container img,\n.onboarding form .photo-container img{\n    width: 100%;\n}\n.additem form .uploaded-pic-delete-container #uploaded-pic img,\n.onboarding form .uploaded-pic-delete-container #uploaded-pic img{\n    width: 80%;\n}\n.additem form .custom-file-upload,\n.onboarding form .custom-file-upload {\n    border: 1px solid #ccc;\n    display: contents;\n    padding: 6px 12px;\n    cursor: pointer;\n\n}\n.additem form .file-upload-div,\n.onboarding form .file-upload-div{\n    display: flex;\n    flex-direction: column\n\n}\n.additem form .custom-file-upload .fa-cloud-upload,\n.onboarding form .custom-file-upload .fa-cloud-upload {\n    justify-content: center;\n}\n.onboarding h2,\n.additem h2{\n    position: relative;\n    margin-left: 4%;\n    margin-bottom: 0%;\n}\n/*-----AddItem-----*/\n.additem {\n    border-top: solid 1px rgb(213, 213, 213);\n}\n\n.additem form {\n    display: flex;\n    justify-content: center;\n}\n\n.additem form section {\n    display: flex;\n    flex-direction: column;\n    padding: 20px;\n    width: 45%;\n    text-align: start;\n}\n\n.additem form input,\n.additem form select {\n    padding: 15px 30px;\n    margin: 10px 0;\n    font-size: 15px;\n    border: solid 2px rgb(219, 219, 219);\n    border-radius: 10px;\n}\n\n.additem form label {\n    margin: 10px 0;\n}\n\n.additem form .multiple-input-container {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n}\n\n.additem form input::-webkit-outer-spin-button,\n.additem form input::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\n.additem form .multiple-input-container input {\n    margin-right: 10px;\n}\n\n.additem form .multiple-input-container label {\n    padding: 10px;\n    border: solid 2px rgb(144, 144, 144);\n    border-radius: 10px;\n    transition: all 0.3s;\n    margin-right: 10px;\n}\n\n.additem form input[type=radio] {\n    display: none;\n}\n\n.additem form input[type=number] {\n    width: 25%;\n}\n.additem form select {\n    width: 80%;\n}\n\n.additem form input[type=radio]:checked + label {\n    border: solid 2px #5aa168;\n}\n\n.additem form input[type=submit]:hover {\n    background-color: rgb(235, 235, 235);\n}\n\n.additem form input[type=submit]:active {\n    background-color: rgb(226, 115, 115);\n}\n\n/*----Dashboard-----*/\n.dashboard {\n    display: flex;\n    justify-content: space-between;\n}\n\n.swipe-container {\n    width: 70vw;\n    display: flex;\n    height: 100vh;\n    z-index: 1;\n\n    align-items: flex-start;\n    flex-direction: column;\n    position: absolute;\n    right: 0%;\n\n}\n.swipe-container .swipe-container-header{\n    background: linear-gradient(45deg, #83ae48, #5aa168);\n    height: 100px;\n    width: 100%;\n    justify-content: flex-end;\n    align-items:center;\n    display: flex;\n}\n\n.swipe-container-header-add-item-container {\n    height: 75px;\n    width: 75px;\n    position: relative;\n    overflow: hidden;\n    margin: 10px;\n    display: flex;\n    align-items:center;\n\n}\n.swipe-container-header-add-item-container img {\n    height: 70%;\n    width: 100%;\n}\n\n.card-container {\n    background: linear-gradient(45deg, #83ae48, #5aa168);\n    width: 100%;\n    height: 600px;\n    overflow-y: auto;\n    display: flex; /* Optional, if you have other static content */\n    justify-content: center;\n    align-items: center;\n}\n\n\n.dashboard .swipe-info {\n    position: absolute;\n    bottom: 0;\n    padding: 10px;\n}\n.card-wrapper {\n    position: absolute; /* Required by react-tinder-card */\n    width: 35%;\n    height: 35%;\n    border-radius: 20px;\n    overflow: hidden; /* Keeps content inside rounded corners */\n    transform: translate(-50%, -50%); /* Offset by half its own size */\n}\n.card-content {\n    width: 100%;\n    height: 100%;\n    background-size: cover;\n    background-position: center;\n    position: absolute; /* Required by react-tinder-card */\n\n    /* Flexbox to center the description */\n    display: flex;\n    justify-content: center; /* Horizontal centering */\n    align-items: end;     /* Vertical centering */\n    \n    /* Optional: If you want the text to stay at the bottom instead */\n    /* align-items: flex-end; */\n    /* padding-bottom: 20px; */\n}\n\n.card-description {\n    text-align: center; /* Centers text lines within the description block */\n    color: white;       /* Ensure text is visible on images */\n    padding: 10px;\n    background-color: rgba(0, 0, 0, 0.5); /* Optional: backdrop for readability */\n    border-radius: 10px;\n    width: 100%; /* Prevents text from touching edges */\n    bottom: 0;\n    position: relative;\n}\n.card-description img {\n    width: 7%;\n    height: 7%;\n    filter: invert(100%);\n    margin-bottom: 0%;\n}\n.card-description .description img{\n    margin-top: 1%;\n    margin-left: 3%;\n}\n.card-description .specs img{\n    margin-top: 3%;\n    margin-right: 3%;\n    margin-left: 3%;\n}\n.card-description h4 {\n    color: #fff;\n    margin-bottom: 0%;\n    margin-top: 0%;\n}\n.card-description span {\n    color: #d8d7d7;\n    margin-left: 0%;\n    margin-top: 0%;\n}\n/*-------- Chat Container --------*/\n.chat-container {\n    background-color: rgb(255, 255, 255);\n    box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,\n    rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;\n    width: 30%;\n    text-align: left;\n    z-index: 1;\n    position: absolute;\n    top: 0;\n    left: 0;\n    display: flex;\n    flex-direction: column;\n}\n\n.chat-container .chat-container-header {\n    background: linear-gradient(45deg,  #83ae48, #5aa168);\n    height: 100px;\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.chat-container .option {\n    border: none;\n    background-color: rgb(255, 255, 255);\n    border-bottom: solid 4px #5aa168;\n    font-size: 20px;\n    margin: 2px;\n    padding: 10px;\n}\n\n.chat-container .option:disabled {\n    border-bottom: solid 4px rgb(187, 187, 187);\n}\n\n.chat-container .profile,\n.chat-container .log-out-icon {\n    display: flex;\n    align-items: center;\n    padding: 10%;\n    width: 50%;\n    color: rgb(255, 255, 255);\n}\n\n/* Image styling */\n.image {\n    width: 100%;\n}\n\n.profile-img-container{\n    height: 50px;\n    width: 50px;\n    border-radius: 15px;\n    overflow: hidden;\n    margin: 10px;\n    position:relative;\n}\n\n.profile-img-container img {\n    width: 100%;\n}\n/*-------- Chat Display --------*/\n.chat-display{\n    padding: 5px;\n    overflow-y: auto;\n    height: 40vh;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n}\n.chat-display .img-container{\n    width: 20%;\n    height: 20%;\n    margin-bottom: 20px;\n    margin-top: 20px;\n    border-radius: 12px;\n}\n.chat-display .message-other-user .img-container{\n    position: absolute;\n    right: 0px;\n}\n\n.matches-display {\n    padding-top: 10px;\n    overflow-y: scroll;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n    height: 60vh;\n}\n.matches-display .match-card{\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    width: 30%;\n    margin-bottom: 10px;\n    border-radius: 12px;\n\n}\n.own-card {\n    display: flex;\n    position: relative; /* Anchor for absolute children */\n    width: 30%;       /* Your desired width */\n    border-radius: 12px;\n    cursor: pointer;\n    display: flex;\n    margin-bottom: 10px;\n}\n\n/* --- Overlays --- */\n\n.edit {\n    position: absolute;\n    top: 0%;\n    left: 0%;\n    width: 30%;\n    height: 30%;\n    background-color: rgba(0,0,0,0.3);\n    border-radius: 12px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    z-index: 2; /* Above image */\n    transition: transform 0.2s, background-color 0.2s;\n}\n\n.edit:hover {\n    transform: scale(1.1);\n}\n\n.edit img {\n    width: 90%;\n    height: 90%;\n}\n\n.counter {\n    position: absolute;\n    background-color: rgba(0,0,0,0.3);\n    top: 0%;\n    right: 0%;\n    color: white;\n    border-radius: 12px;\n    font-size: 100%;\n    font-weight: bold;\n    z-index: 2; /* Above image */\n    width: 30%;\n    height: 30%;\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n/* --- Background Image --- */\n\n.img-container {\n    width: 100%;\n    height: 100%;\n}\n\n.img-container img {\n    width: 100%;\n    height: 100%;\n    border-radius: 15px;\n    object-fit: cover;\n    display: block;\n}\n/*-------- Chat Input --------*/\n.chat-input {\n    padding: 5px;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    flex: 1;\n}\n/*--------- Slider Bar -------*/\n.slider-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: center; /* Centers items horizontally */\n    align-items: center;     /* Centers items vertically */\n    gap: 20px;               /* Adds space between elements */\n    \n    /* Optional: Define width/height if needed */\n    width: 100%;\n    padding: 20px 0;\n    \n    /* If you want it fixed at the bottom of the swipe-container */\n    /* position: absolute; */\n    /* bottom: 20px; */\n}\n  \n.slider {\n    width: 300px;\n    max-width: 90%;\n    margin: 10px 0;\n}\n\n.value-display {\n    font-size: 18px;\n    font-weight: bold;\n    color: #333;\n}\np{\n    text-align: center;\n    margin: 0 5px 0 5px;\n    font-size: 34px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
